import { Box, IconButton, InlineLinkButton, Typography } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";
import "./EquipmentDisclaimerToast.scss";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";

export type EquipmentDisclaimerToastProps = {
    show: boolean;
    onClose: () => void;
    onLinkClick: () => void;
}

const EquipmentDisclaimerToast = ({
    show,
    onClose,
    onLinkClick,
}: EquipmentDisclaimerToastProps) => {
    const intl = useIntl();
    const navigate = useNavigate();
    
    const toastClasses = clsx('tcsp-equipment-disclaimer-toast', { 'tcsp-equipment-disclaimer-toast--open' :show})

    const handleClick = () => {
        navigate("/finance");
    }

    return (
        <Box className={toastClasses} px={20} py={3} flexDirection="row" gap={3} alignItems="center" justifyContent="center">
            <Typography
                variant="Body2"
                text={intl.formatMessage({id: "projects.equipmentToast.text", defaultMessage: "Note that financial options must be updated manually when adding or removing equipment."})}
            />
            <InlineLinkButton onClick={onLinkClick} variant="Body2" href="" text={intl.formatMessage({id: "projects.equipmentToast.FinancingLinkText", defaultMessage: "Financing & offer"})} />
            <Box className="tcsp-equipment-disclaimer-toast__close-btn">
                <IconButton icon="close" onClick={handleClick} size="Medium" />
            </Box>
        </Box>
    )
}

export default EquipmentDisclaimerToast;
